import { Box, Typography } from "@mui/material";

/**
 * Cabecera de página estándar (banner de marca azul).
 * Reemplaza el banner celeste ad-hoc duplicado en las vistas de tabla.
 * Sigue los tokens de design.md: gradiente de marca, radio 15px y sombra azul.
 *
 * Props:
 *  - title:          título principal (string o node)
 *  - subtitle:       línea secundaria opcional (con opacidad reducida)
 *  - startAdornment: elemento a la izquierda del título (ej: botón "volver")
 *  - actions:        elemento alineado a la derecha (ej: botón de acción)
 *  - sx:             overrides puntuales del contenedor
 */
const PageHeader = ({ title, subtitle, startAdornment, actions, sx = {} }) => {
  return (
    <Box
      sx={{
        background: "linear-gradient(195deg, #002C54, #003f77)",
        borderRadius: "15px",
        color: "white",
        padding: "1.5rem 2rem",
        boxShadow: "0 8px 24px rgba(0,44,84,0.25)",
        display: "flex",
        alignItems: "center",
        gap: "1.1rem",
        width: "100%",
        marginBottom: "1.5rem",
        ...sx,
      }}
    >
      {startAdornment}
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography
          sx={{ fontSize: "22px", fontWeight: 700, letterSpacing: "0.5px" }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ fontSize: "13px", fontWeight: 400, opacity: 0.8 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions}
    </Box>
  );
};

export default PageHeader;
